import objectPath from 'object-path'
import { hasRules, onCheckRules } from '../rules/Action'

export const getFirstDefinedValue = (data = {}, keys = []) => {
  let value

  keys.find((key) => {
    if (!key || !objectPath.has(data, key)) return false

    value = objectPath.get(data, key)
    return true
  })

  return value
}

const getFormPropPath = (prop, formComponentName) => {
  if (!prop) return ''
  if (formComponentName) return `${formComponentName}.${prop}`

  return prop
}

const addReceiveRuleKey = (keys = [], key = '') => {
  if (!key) return keys
  if (keys.includes(key)) return keys

  keys.push(key)
  return keys
}

export const getModalPropKeys = ({
  prop = '',
  propKey = '',
  jsonKey = '',
  fullPropKey = '',
} = {}) => {
  let keys = []
  addReceiveRuleKey(keys, fullPropKey)
  addReceiveRuleKey(keys, propKey)
  addReceiveRuleKey(keys, prop && jsonKey ? `${prop}.${jsonKey}` : '')
  addReceiveRuleKey(keys, jsonKey)
  addReceiveRuleKey(keys, prop)

  return keys
}

export const getModalSendProps = (sendProps) => {
  if (!sendProps) return sendProps
  if (Array.isArray(sendProps)) return sendProps
  if (typeof sendProps === 'object') return Object.values(sendProps)

  return []
}

export const findModalSendProp = (sendProps = [], receive = {}) => {
  let receiveKeys = getModalPropKeys(receive)

  return sendProps.find((send = {}) => {
    let sendKeys = getModalPropKeys(send)

    return sendKeys.find((sendKey) => receiveKeys.includes(sendKey))
  })
}

const getModalReceiveSystemValue = ({
  source = {},
  data = {},
  prop = '',
  field = '',
}) => {
  if (!field) return

  if (objectPath.has(source, field)) {
    return objectPath.get(source, field)
  }

  if (source && typeof source === 'object') {
    let sourceKey = Object.keys(source).find((key) =>
      objectPath.has(source, `${key}.${field}`),
    )
    if (sourceKey) {
      return objectPath.get(source, `${sourceKey}.${field}`)
    }
  }

  if (prop && objectPath.has(data, `${prop}.${field}`)) {
    return objectPath.get(data, `${prop}.${field}`)
  }

  return objectPath.get(data, field)
}

export const updateModalReceiveFormDataBySystem = ({
  formData = {},
  newSearchData,
  data = {},
  source = {},
  prop = '',
  system = [],
  formComponentName,
  isPage,
}) => {
  system.forEach(({ field, systemKey, systemName }) => {
    let name = systemName
    if (name && formComponentName) {
      name = `${formComponentName}.${name}`
    }

    let value = getModalReceiveSystemValue({
      source,
      data,
      prop,
      field,
    })
    if (value === undefined) return

    if (systemKey) objectPath.set(formData, systemKey, value)
    if (name) objectPath.set(formData, name, value)

    if (isPage === 1 && newSearchData) {
      if (systemKey) objectPath.set(newSearchData, systemKey, value)
      if (name) objectPath.set(newSearchData, name, value)
    }
  })

  return {
    formData,
    newSearchData,
  }
}

const getModalReceiveRuleKeys = (
  receiveProps = [],
  formComponentName = '',
) => {
  let keys = []

  receiveProps.forEach(({ prop, propKey, fullPropKey, systemKey }) => {
    addReceiveRuleKey(keys, systemKey)
    addReceiveRuleKey(keys, fullPropKey)
    addReceiveRuleKey(keys, propKey)
    addReceiveRuleKey(keys, getFormPropPath(prop, formComponentName))
  })

  return keys
}

export const runModalReceiveRules = ({
  designContext = {},
  formData = {},
  receiveProps = [],
  formComponentName = '',
  status = {},
}) => {
  let { jsonForm = {} } = designContext
  if (!hasRules(jsonForm)) return formData

  let ruleKeys = getModalReceiveRuleKeys(receiveProps, formComponentName)
  if (ruleKeys.length === 0) {
    let ruleFormData = onCheckRules(designContext, formData, null, {
      ...status,
      isDebounce: false,
    })

    return ruleFormData || formData
  }

  ruleKeys.forEach((ruleKey) => {
    let ruleFormData = onCheckRules(designContext, formData, ruleKey, {
      ...status,
      isDebounce: false,
    })
    formData = ruleFormData || formData
  })

  return formData
}

export const getModalReceiveFileValue = (
  data = {},
  { prop, propKey, fullPropKey } = {},
) => {
  let dataKey = propKey || fullPropKey

  return getFirstDefinedValue(data, [
    dataKey ? `@sendData.${dataKey}` : '',
    dataKey,
    fullPropKey ? `@sendData.${fullPropKey}` : '',
    fullPropKey,
    prop ? `@sendData.${prop}` : '',
    prop,
  ])
}

export const updateModalReceiveFilesFormData = ({
  formData = {},
  newSearchData,
  data = {},
  prop,
  propKey,
  fullPropKey,
  systemKey,
  formComponentName,
  isPage,
}) => {
  let value = getModalReceiveFileValue(data, {
    prop,
    propKey,
    fullPropKey,
  })

  if (value === undefined) {
    return {
      formData,
      newSearchData,
      value,
    }
  }

  let propPath = getFormPropPath(prop, formComponentName)

  if (systemKey) objectPath.set(formData, systemKey, value)
  if (propPath) objectPath.set(formData, propPath, value)

  if (isPage === 1 && newSearchData) {
    if (systemKey) objectPath.set(newSearchData, systemKey, value)
    if (propPath) objectPath.set(newSearchData, propPath, value)
  }

  return {
    formData,
    newSearchData,
    value,
  }
}
